// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"951":"57c5bd1be71b98cf","2742":"7e83708d650ae5f0","6851":"d5e89901ff60b6b4"}[chunkId] + ".css";
};